import React, { useEffect } from 'react'
import CommonTablePage from '../../../../components/common/common-table/common-table-page'
import CustomerGroup1ManagementColumnModel from './customer-group1-management-column-model'
import { urlKey } from '../../../../services/api/api-urls'
import { useDocumentTitle } from '../../../../services/title/useDocumentTitle'

const CustomerGroup1ManagementPage = (): any => {
  // useEffect(() => {
  //   document.title = "Customer Group 1 Management";
  //   },[]);  
    useDocumentTitle();
  return (
    <CommonTablePage
      urlInfoKey={urlKey.CustomerGroup1}
      title="Customer Group 1 Management"
      column={CustomerGroup1ManagementColumnModel.CustomerGroup1ManagementColumn}
      mappingUpdateData={(dataDetail: any, type: any) => {
        dataDetail.priceVisible = parseInt(dataDetail.priceVisible)
        return dataDetail
      }}
    />
  )
}

export default CustomerGroup1ManagementPage
